import React, { useState, ReactNode, useEffect } from 'react'
import { AnimatePresence, useAnimation } from 'framer-motion'
import * as css from './styles'

interface SwiperProps {
  children: ReactNode
  slideWidth?: number
  defaultActiveIndex?: number
}

export const Swiper = ({ children, slideWidth = 250, defaultActiveIndex = 0 }: SwiperProps) => {
  const [currentIndex, setCurrentIndex] = useState(0)
  const controls = useAnimation()

  useEffect(() => {
    controls.set({ x: -defaultActiveIndex * slideWidth })
    setCurrentIndex(defaultActiveIndex)
  }, [defaultActiveIndex])

  const handleDotClick = (index: number) => {
    setCurrentIndex(index)
    void controls.start({ x: -index * slideWidth })
  }

  const handleSwipe = (direction: number) => {
    const newIndex =
      (currentIndex + direction + React.Children.count(children)) % React.Children.count(children)
    setCurrentIndex(newIndex)
    void controls.start({ x: -newIndex * slideWidth })
  }

  return (
    <div>
      <css.Container
        style={{}}
        drag="x"
        dragConstraints={{ left: 0, right: 0 }}
        dragElastic={1}
        onDragEnd={(_, info) => {
          const swipeThreshold = 100
          if (info.offset.x > swipeThreshold) {
            handleSwipe(-1)
          } else if (info.offset.x < -swipeThreshold) {
            handleSwipe(1)
          } else {
            void controls.start({ x: -currentIndex * 100 })
          }
        }}
        animate={controls}
      >
        <AnimatePresence exitBeforeEnter initial={false}>
          {React.Children.map(children, (child, index) => (
            <div
              key={index}
              css={{
                width: '100%',
                flex: '0 0 100%',
                // opacity: index === currentIndex ? 1 : 0,
              }}
            >
              {child}
            </div>
          ))}
        </AnimatePresence>
      </css.Container>
      <css.DotContainer>
        {Array.from({ length: React.Children.count(children) }).map((_, index) => (
          <css.Dot
            key={index}
            active={index === currentIndex}
            onClick={() => {
              handleDotClick(index)
            }}
          />
        ))}
      </css.DotContainer>
    </div>
  )
}
